<template>
<!-- 灰度配置查看 -->
  <div>
    <el-descriptions
      class="margin-top"
      :title="$t('button.grayscaleConfig')"
      :column="3"
      border
    >
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text5") }} </template>
        {{ formalUpgradeInfo.bikeCategoryName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text6") }} </template>
        {{ formalUpgradeInfo.bikeTypeName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text198") }} </template>
        <div v-for="(item, index) in hwTypeList" :key="index">
          <div v-if="formalUpgradeInfo.hwType == item.value">
            {{ item.label }}
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text214") }} </template>
        {{ formalUpgradeInfo.hwVersion }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text200") }} </template>
        {{ formalUpgradeInfo.firmwareName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text201") }} </template>
        {{ formalUpgradeInfo.fwVersion }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{$t('omission.text4')}} </template>
        {{ sizeReset(formalUpgradeInfo.fileSize)  }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text229") }} </template>
        {{
          formalUpgradeInfo.upgradeType == 1
            ? $t("pages.equipment.text178")
            : "4g"
        }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text212") }} </template>
        {{ formalUpgradeInfo.startValidTime }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> {{ $t("pages.equipment.text230") }} </template>
        {{ formalUpgradeInfo.upgradeIntro }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>


<script>
import { sizeReset } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      hwTypeList: [
        {
          label: this.$t("pages.equipment.text178"),
          value: 10,
        },
        {
          label: this.$t("pages.equipment.text202"),
          value: 15,
        },
        {
          label: this.$t("pages.equipment.text203"),
          value: 20,
        },
        {
          label: this.$t("pages.equipment.text204"),
          value: 25,
        },
        {
          label: this.$t("pages.equipment.text205"),
          value: 30,
        },
        {
          label: this.$t("pages.equipment.text206"),
          value: 35,
        },
        {
          label: this.$t("pages.equipment.text207"),
          value: 40,
        },
        {
          label: this.$t("pages.equipment.text208"),
          value: 45,
        },
      ],
    };
  },
  props: ["formalUpgradeInfo"],
  methods:{
     sizeReset(e) {
      return sizeReset(e);
    },
  }
};
</script>